import AppLayout from '@/layout/AppLayout.vue'
const CurrentPosition = () => import('@/view/futures/CurrentPosition.vue')
const HistoricalCommissions = () => import('@/view/futures/HistoricalCommissions.vue')

const routes = {
  path: '/Futures',
  name: 'Futures',
  icon: 'icon-a-lianhe41',
  meta: {
    title: 'futures.futuresTrade'
  },
  children: [
    {
      path: '/Futures/CurrentPosition',
      name: 'FuturesCurrentPosition',
      meta: {
        title: 'futures.currentPosition'
      },
      component: CurrentPosition,
    },
    {
      path: '/Futures/HistoricalCommissions',
      name: 'FuturesHistoricalCommissions',
      meta: {
        title: 'table.tradeHistoryTable'
      },
      component: HistoricalCommissions,
    }
  ]
}

const components = {}

export default {
  routes,
  components,
}
